var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-select", {
    attrs: {
      filterable: "",
      remote: "",
      placeholder: "WorkWeixinRelatedApproval 企业微信关联申请单",
      clearable: ""
    },
    model: {
      value: _vm.relatedApprovalId,
      callback: function($$v) {
        _vm.relatedApprovalId = $$v
      },
      expression: "relatedApprovalId"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23c50ce8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c50ce8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/WorkWeixinRelatedApproval.vue
// module id = 970
// module chunks = 75